export default __webpack_public_path__ + "static/media/vip.9454cc4b.svg";